import React, { Fragment, useState, useEffect } from "react";
import { useRouter } from "next/router";
import { FiSearch } from "react-icons/fi";
import styles from "./news_search.module.scss";
import { objectToQueryString } from "@unisearch/helpers";

export const NewsSearch = ({ customClasses, loading, ...props }) => {
  const router = useRouter();
  const { format } = router.query;

  const [searchObj, setSearchObj] = useState({
    limit: 8,
    page: 1,
    sortOrder: "DESC",
  });

  const submitHandler = (e) => {
    e.preventDefault();
    let query = objectToQueryString(searchObj);
    router.push({
      pathname: "/news/search",
      query: query,
    });
    return true;
  };

  useEffect(() => {
    if (format) {
      setSearchObj((prev) => ({ ...prev, format: format }));
    }
  }, [format]);

  return (
    <Fragment>
      <div
        className={`${styles.search_wrapper} ${
          customClasses?.wrapperClass ? customClasses.wrapperClass : ""
        }`}
      >
        <form onSubmit={submitHandler}>
          <div className={styles.input_wrapper}>
            <FiSearch className={styles.search_icon} onClick={submitHandler} />
            <input
              type="text"
              placeholder="Search Here"
              onChange={(e) =>
                setSearchObj((prev) => ({ ...prev, query: e.target.value }))
              }
              value={searchObj.query ?? ""}
            />
          </div>
        </form>
      </div>
    </Fragment>
  );
};

export default NewsSearch;
